import { SetResidentialDetail, state$ } from './userAccountDriver'
import { state$ as navigationState$ } from '@core/State/Navigation'
import { trackAccountNumber } from '@classic/Foundation/Analytics/Analytics'
import { appHistory } from '@core/Utils/routing/history'
import { AppRoutes } from '@core/AppRoutes'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { store } from '@core/Store'
import { toggleIsDropDownOpen } from '@core/Areas/AppHeader/Store'
import { fetchAccountBalanceAsync, fetchCampaignsAsync } from './async-signals'
import { register as registerUserAccountPushData } from './push-data'
import { BetAccountKey, BetAccountRecord, BetAccountRepo } from '@core/Data/Account/betAccount'
import { syncLoginStateWithNativeApp } from '@core/NativeServices/LoginStateRegister/LoginStateRegister'
import { updateMetadata } from '@core/NativeServices/MetadataService'
import { trackOptimoveEvent } from '@core/Services/Optimove/optimove'
import { trackLogout } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { handleAutoRegisterFcmToken } from '@core/Utils/notifications/pushNotificationAlerts'
import { startListening } from '@core/Store/listenerMiddleware'
import { setFeatures } from '@core/State/FeatureFlags/Store'
import { getFeaturesIsUserAnonymous } from '@core/State/FeatureFlags/Store/selectors'

export function registerUserAccountSideEffects(): void {
  registerUserAccountPushData()

  startListening({
    actionCreator: setFeatures,
    effect: (_, listenerApi) => {
      const currentIsUserAnonymous = getFeaturesIsUserAnonymous(listenerApi.getState())
      const hasLoggedInAndFetchedFlags = currentIsUserAnonymous === false
      if (hasLoggedInAndFetchedFlags) fetchCampaignsAsync()
    },
  })

  // Handle Side Effects Based on State Changes
  state$
    .pairwise()
    .distinctUntilChanged()
    .subscribe(([prevState, newState]) => {
      const hasLoggedOut = prevState.isLoggedIn === true && newState.isLoggedIn === false
      const hasLoggedIn = !prevState.isLoggedIn && newState.isLoggedIn === true

      if (hasLoggedIn && newState.accountNumber) {
        fetchAccountBalanceAsync()
        updateMetadata()
        trackAccountNumber(`${newState.accountNumber || ''}`)
        handleAutoRegisterFcmToken(newState.accountNumber)

        BetAccountRepo.getPromise(BetAccountKey).then((betAccount: BetAccountRecord) => {
          syncLoginStateWithNativeApp(betAccount)
          const { ResidentialCountry, ResidentialState } = betAccount
          SetResidentialDetail([ResidentialCountry, ResidentialState])

          if (typeof betAccount.IsIDVerified === 'boolean') {
            trackOptimoveEvent({
              eventName: 'account_verification_status',
              data: { verified: betAccount.IsIDVerified },
            })
          }
        })
      }

      if (hasLoggedOut) {
        trackLogout()
        queryClient.removeQueries({ queryKey: [queryKeys.accountBase] })
        store.dispatch(toggleIsDropDownOpen(false))

        navigationState$.take(1).subscribe(navState => {
          if (navState.get('currentUrl')?.includes('account')) {
            appHistory.push(AppRoutes.Home)
          }
        })
      }
    })
}
